export default {
  error: false,
  email: null,
  password: null,
  confirmPassword: null,
  currentPassword: null
};
